import { StripePriceFragmentFragment } from '@/__generated__/graphql';

export const getDefaultPriceId = (
  prices?: StripePriceFragmentFragment[],
): string | undefined => prices?.[0]?.id ?? undefined;
